// ** Context Imports
import dynamic from 'next/dynamic'
import { PreviewSkeletonType } from 'src/lib/types/uiPreview'
import Pill from '../skeletons/Pill'
import { OrderSummaryConfigType } from 'src/lib/types/customizeUI'
import { ChevronDown, ChevronUp, ShoppingCart } from 'react-feather'
import { ItemCard } from './ItemCard'
import { useEffect, useState } from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'

const ImageContainer = dynamic(() => import(`../../ImageContainer`), { ssr: false })

interface PreviewHeaderProps {
  logoUrl: string
  skeleton: PreviewSkeletonType
  isLogoHidden?: boolean
  showTotal?: { isEnabled?: boolean; showStrikeThrough?: boolean }
  orderSummaryConfig?: OrderSummaryConfigType
  shouldShowPillAsLogo?: boolean
}

const PreviewHeader: React.FC<PreviewHeaderProps> = ({
  logoUrl,
  skeleton,
  isLogoHidden,
  showTotal,
  orderSummaryConfig,
  shouldShowPillAsLogo = false
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const { t } = useLocale()

  useEffect(() => {
    if (!orderSummaryConfig) return
    if (orderSummaryConfig.showOrderSummaryAs === 'TILE' && isExpanded) {
      setIsExpanded(false)
    }
  }, [orderSummaryConfig?.showOrderSummaryAs])

  const toggleOrderToatlSummary = () => {
    setIsExpanded(!isExpanded)
  }
  return (
    <div className='relative flex py-5 px-5 justify-between items-center w-full h-[64px] '>
      {!Boolean(isLogoHidden) && !shouldShowPillAsLogo ? (
        <ImageContainer
          height={40}
          maxWidth={144}
          imageSource={logoUrl ?? ''}
          defaultImage={'images/image-placeholder.svg'}
          altText={'Brand logo'}
        />
      ) : (
        <Pill height={2} width={2} />
      )}
      {Boolean(showTotal) && showTotal?.isEnabled ? (
        <div className='flex flex-col'>
          {orderSummaryConfig &&
          Boolean(!orderSummaryConfig.isOnePageCheckoutEnable) &&
          orderSummaryConfig.showOrderSummaryAs === 'TILE' ? (
            <div className='flex flex-col'>
              {showTotal?.showStrikeThrough && (
                <div className='text-gray-dark text-xs line-through text-right'>₹2799</div>
              )}
              <span>₹2100</span>
            </div>
          ) : (
            <>
              <div onClick={toggleOrderToatlSummary}>
                <div className='text-right flex-grow space-y-1'>
                  <div className='font-medium text-sm mt-1'>Order total</div>
                  {showTotal?.showStrikeThrough && (
                    <div className='text-gray-dark text-xs line-through text-right mr-2'>₹2799</div>
                  )}
                  <div className='flex text-sm font-semibold items-center cursor-pointer'>
                    ₹1,645<span className='font-normal text-xs'>.50</span>
                    <ChevronDown className='h-4 w-4 ml-1 text-coal-dark transform duration-700 ease-in-out' />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      ) : (
        <div className='flex'>
          {skeleton?.config?.map((item: any, index: number) => {
            return <Pill height={item?.height} width={item?.width} key={index} />
          })}
        </div>
      )}

      {isExpanded &&
        orderSummaryConfig &&
        (orderSummaryConfig.isOnePageCheckoutEnable || orderSummaryConfig.showOrderSummaryAs === 'HEADER') && (
          <div className='absolute shadow-2xl top-0 left-0 right-0 z-20 border-1 border-gray-light rounded-2xl space-y-4 w-full flex flex-col bg-white'>
            <div className='flex mt-2 w-full rounded-2xl bg-white flex-row items-center px-4 pt-4 justify-between'>
              <div className='flex flex-row items-center space-x-2'>
                <ShoppingCart className='w-4 h-4' />
                <p className='text-sm font-medium text-coal-dark'>Order total</p>
                <p className='text-sm text-coal-light'>{t('items', { count: 3 })}</p>
              </div>
              <div className=' text-sm font-semibold space-y-1' onClick={toggleOrderToatlSummary}>
                <div className=''>
                  {showTotal?.showStrikeThrough && (
                    <div className='text-gray-dark text-xs line-through text-right mr-3'>₹2799</div>
                  )}
                </div>
                <div className='flex items-center '>
                  ₹1,645<span className='font-normal text-xs'>.50</span>
                  <span>
                    {' '}
                    <ChevronUp className='h-4 w-4 text-coal-dark transform duration-700 ease-in-out' />
                  </span>
                </div>
              </div>
            </div>
            <div className='bg-gray-50'>
              <div className='p-4 py-6 space-y-5'>
                {[...Array(3)].map((_, index) => (
                  <ItemCard key={index} orderSummaryConfig={orderSummaryConfig} />
                ))}
              </div>
            </div>
            <div className='space-y-4 px-4 pb-6'>
              <div className='text-xs font-medium space-y-1'>
                <div className='flex justify-between font-semibold'>
                  <span>Item total</span>
                  <span>₹2100</span>
                </div>
                <div
                  className='flex justify-between'
                  style={{
                    color: '#2C874A'
                  }}
                >
                  <span>Savings</span>
                  <span>-₹455</span>
                </div>
                <div className='flex justify-between'>
                  <span>Shipping</span>
                  <span>FREE</span>
                </div>
              </div>
              <div className='flex text-xs justify-between font-semibold'>
                <span>Grand total</span>
                <span>₹1645</span>
              </div>
            </div>
          </div>
        )}
    </div>
  )
}

export default PreviewHeader
